'use strict';

import jQuery from 'jquery';

var Collection = (function($) {

  // Define a new Collection function
  function Collection(fetchAction) {

    // Define the default empty state for the model
    this._state = {
      collection: [],
      updated: 0
    };
  }

  /**
   * Sets the underlying list structure of the collection
   *
   * @param {Array} list An array of values to set the underlying data to
   * @returns {Array} The array the underlying data is set to
   */
  Collection.prototype.set = function set(list) {

    // Set the state
    this._state.collection = list;

    return this._state.collection;
  };

  /**
   * Gets an element at a specific index from the collection
   *
   * @param {Number} index The index of the element to get
   * @returns The model at the given index
   */
  Collection.prototype.at = function at(index) {

    return this._state.collection[index];
  };

  /**
   * A function for retrieving the number of elements in the collection
   *
   * @returns {Number} The number of elements in the collection
   */
  Collection.prototype.length = function length() {

    return this._state.collection.length;
  };

  /**
   * Performs a traditional map over the underlying list and returns a new
   * collection of the transformed list
   *
   * @param {Function} fn The function to map with
   * @param {Object} thisArg The argument to use as the this value
   * @returns {Collection} A new collection of the mapped elements
   */
  Collection.prototype.map = function map(fn, thisArg) {

    // Create a new collection
    var c = new Collection();

    // Set the underlying list of the collection to the map of the original
    c.set(this._state.collection.map(fn, thisArg));

    // Return the new collection
    return c;
  };

  /**
   * Executes a function on each of the elements of the underlying list
   *
   * @param {Function} fn The function to execute on each element
   * @param {Object} thisArg The argument to use as the this value
   */
  Collection.prototype.forEach = function forEach(fn, thisArg) {

    // Simply loop through the collection calling the function on each
    this._state.collection.forEach(fn, thisArg);
  };

  /**
   * Slices the collection and returns a new collection. Uses the underlying
   * array's slice method
   *
   * @param {Number} begin Zero based index to start extraction
   * @param {Number} end Zero-based index at which to end extraction, non-inclusive.
   * @returns {Collection}
   */
  Collection.prototype.slice = function slice(begin, end) {

    // Create a new collection
    var c = new Collection();

    // Set the underlying list of the collection to the map of the original
    c.set(this._state.collection.slice(begin, end));

    // Return the new collection
    return c;
  };

  /**
   * Returns the collection in array format
   *
   * @returns {Array} The collection as an array
   */
  Collection.prototype.toArray = function toArray() {

    return this._state.collection;
  };

  return Collection;
})(jQuery);

export default Collection